import React, { useState } from "react";
import {
    View,
    ScrollView,
    StyleSheet,
    TouchableOpacity,
    Platform,
} from "react-native";
import { Text, Switch } from "react-native-paper";
import { CustomIcon } from "../../../components/CustomIcon";
import { useThemeSettings } from "../../../ThemeProvider";
import { useNavigation } from "@react-navigation/native";
import { ROUTES } from "../../../shared/constants/routes";
import { useTrackScreenTime } from "../../../analytics/useTrackScreenTime";
import { ModalType, useModalStore } from "../../../store/modalStore";
import { useTranslation } from "react-i18next";
import { useUserStore } from "../../../store/userStore";
import { trackInteraction } from "../../../analytics/analyticsUtil";
import { ACTION_TYPE, ANALYTICS_EVENT } from "../../../analytics/types";
import { signOutUser, bootstrapAuth } from "../../../services/authService";

export default function SettingsScreen() {
    useTrackScreenTime(ROUTES.SETTINGS)
    const navigation = useNavigation<any>();

    const { theme } = useThemeSettings();
    const { t } = useTranslation();
    const [notifications, setNotifications] = useState(true);
    const [autoplay, setAutoplay] = useState(false);

    const setModalShown = useModalStore((s) => s.setModalShown);

    const RowDivider = () => <View style={styles.divider} />;

    const SectionHeader = ({ title }: { title: string }) => (
        <Text style={[styles.sectionTitle, { color: theme?.colors?.primary }]}>
            {title}
        </Text>
    );
    const { user, setUser } = useUserStore();

    const ToggleRow = ({
        label,
        value,
        onChange,
    }: {
        label: string;
        value: boolean;
        onChange: (v: boolean) => void;
    }) => (
        <>
            <View style={styles.row}>
                <Text style={[styles.rowLabel, { color: theme?.colors?.textPrimary }]}>{label}</Text>

                <Switch
                    value={value}
                    onValueChange={onChange}
                    color={theme?.colors?.primary}
                />
            </View>
            <RowDivider />
        </>
    );

    const NavigationRow = ({
        label,
        onPress,
        rightText,
        isDestructive,
    }: {
        label: string;
        onPress?: () => void;
        rightText?: string;
        isDestructive?: boolean;
    }) => (
        <>
            <TouchableOpacity style={styles.row} onPress={onPress}>
                <Text
                    style={[
                        styles.rowLabel,
                        { color: theme?.colors?.textPrimary },
                        isDestructive && { color: theme?.colors?.error || "#D22" },
                    ]}
                >
                    {label}
                </Text>

                {rightText ? (
                    <Text style={[styles.rightText, { color: theme?.colors?.textPrimary }]}>{rightText}</Text>
                ) : (
                    <CustomIcon icon="chevron-right" size={14} color={theme?.colors?.textPrimary} />
                )}
            </TouchableOpacity>
            <RowDivider />
        </>
    );

    return (
        <View style={styles.root}>
            <ScrollView contentContainerStyle={{ padding: 24 }} showsVerticalScrollIndicator={Platform.OS === 'web'}>
                {/* NOTIFICATIONS */}
                {/*  <SectionHeader title="Notifications" />
                <ToggleRow
                    label="Enable Notifications"
                    value={notifications}
                    onChange={setNotifications}
                />
                <ToggleRow
                    label="Autoplay"
                    value={autoplay}
                    onChange={setAutoplay}
                /> */}

                {/* ABOUT */}
                <SectionHeader title="About" />
                {/* <NavigationRow label="Client ID" rightText="CL-2026" /> */}
                <NavigationRow label="App Version" rightText="1.2.2" />

                {/* MORE */}
                <SectionHeader title="More" />
                {/*  <NavigationRow label="Default Home" onPress={() => { }} />
                <NavigationRow label="App Language" onPress={() => { }} />
                <NavigationRow label="Content Language" onPress={() => { }} /> */}
                <NavigationRow label="FAQs" onPress={() => { navigation.navigate(ROUTES.FAQ) }} />
                <NavigationRow label="Terms and Condition" onPress={() => { navigation.navigate(ROUTES.TERMS) }} />
                <NavigationRow label="Privacy Policy" onPress={() => { navigation.navigate(ROUTES.PRIVACY) }} />

                {/* DESTRUCTIVE ACTION */}
                {
                    user?.thinkoUser?.email && (
                        <NavigationRow label="Delete Account" isDestructive onPress={() => {
                            setModalShown(ModalType.CONFIRM, {
                                title:'Account deletion',
                                header: t("screens.faqs.question15"),
                                message: t("screens.faqs.answer15"),
                                confirmMessage: 'Confirm Delete',
                                rejectMessage: 'Cancel',
                                onConfirm: async () => {
                                    trackInteraction({
                                        event: ANALYTICS_EVENT.INTERACTION,
                                        action: ACTION_TYPE.CLICK,
                                        screen_name: ROUTES.SETTINGS,
                                        component: 'DeleteAccountConfirm',
                                        context: {
                                            cta: 'delete_account_confirm',
                                            uid: user?.thinkoUser?.uid,
                                            provider: user?.thinkoUser?.provider,
                                        },
                                    });
                                    useModalStore.getState().clearModal();
                                    await signOutUser();
                                    const userData = await bootstrapAuth();
                                    setUser(userData);
                                },
                            })
                        }} />
                    )
                }
                
            </ScrollView>
        </View>
    );
}

const styles = StyleSheet.create({
    root: {
        flex: 1
    },
    screen: {
        flex: 1,
        paddingHorizontal: 22,
        paddingTop: 20,
    },

    sectionTitle: {
        fontSize: 14,
        fontWeight: "500",
        marginTop: 28,
        marginBottom: 12,
    },

    row: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingVertical: 14,
    },

    rowLabel: {
        fontSize: 14,
        color: "#333",
    },

    rightText: {
        fontSize: 14,
        color: "#5A5A5A",
    },

    divider: {
        height: 1,
        backgroundColor: "rgba(0,0,0,0.08)",
        width: "100%",
    },
});